var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4800 2400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f9cf02"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 480,
    fill: "#c4272f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    width: 320,
    height: 480,
    fill: "#015197"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 164,
    r: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 144,
    r: 48,
    fill: "#c4272f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 152,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,92a20,20 0 0,0 40,0c0-8-5-9-5-12 0-3,3-7-3-12 3,5-2,6-2,11 0,5,2,5,2,9a4,4 0 0,1-8,0c0-4,4-8,4-14 0-6-1-8-4-13-3-5-8-9-4-13-6,2-3,10-3,15 0,5-4,8-4,14 0,6,3,7,3,11a4,4 0 0,1-8,0c0-4,2-4,2-9 0-5-5-6-2-11-6,5-3,9-3,12 0,3-5,4-5,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,216V408H112V216ZM208,216V408H248V216ZM120,248V264H200V248ZM120,360V376H200V360ZM120,216H200L160,240ZM120,384H200L160,408Z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#c4272f",
    strokeWidth: 24
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1560,
    r: 212
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M800,1348A106,106 0 0,1 800,1560A106,106 0 0,0 800,1772"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#c4272f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1454,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1666,
    r: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.5d695f22edcdfb6224eabdf9841f91a5.svg";
export { ForwardRef as ReactComponent };